import { render, staticRenderFns } from "./Anormalidades.vue?vue&type=template&id=67793caa&"
import script from "@/Servicios/Anormalidades.js?vue&type=script&lang=js&"
export * from "@/Servicios/Anormalidades.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports